<template>
  <View direction="column" gap="md">
    <Text variant="h2" align="center">What would you like to do?</Text>

    <RadioButtonGroup direction="column">
      <RadioCard
        v-for="option in options"
        :key="option.value"
        v-model="intent"
        name="showingActionIntent"
        :value="option.value"
      >
        <View direction="column" gap="sm">
          <View direction="row" gap="sm" align="center">
            <span class="option-icon" :class="{ danger: option.value === ShowingActionIntent.STOP }">
              <Icon :name="option.icon" size="medium" />
            </span>
            <Text variant="label-medium">{{ option.title }}</Text>
          </View>
          <Text variant="body-medium" color="secondary">{{ option.description }}</Text>
        </View>
      </RadioCard>
    </RadioButtonGroup>
  </View>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { Icon, IconName, RadioButtonGroup, RadioCard, Text, View } from '@tallo/design-system';

import { ShowingActionIntent } from '../interfaces/showing-action-intent.enum';

const props = defineProps<{ renterLabel: string }>();
const intent = defineModel<ShowingActionIntent | null>({ required: true });

const options = computed<
  Array<{
    value: ShowingActionIntent;
    title: string;
    description: string;
    icon: IconName;
  }>
>(() => [
  {
    value: ShowingActionIntent.RESCHEDULE,
    title: 'Suggest a different time',
    description: `Tallo will offer ${props.renterLabel} another time and keep working to get this showing booked.`,
    icon: 'calendar-reschedule',
  },
  {
    value: ShowingActionIntent.STOP,
    title: `Stop working with ${props.renterLabel}`,
    description: `Tallo will stop all communication and scheduling. This can't be undone.`,
    icon: 'slash-circle-01',
  },
]);
</script>

<style scoped lang="scss">
.option-icon {
  display: inline-flex;
  flex-shrink: 0;
}

.option-icon.danger {
  color: var(--t-text-color-danger-primary);
}
</style>
